import axios from 'axios'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import urlSearchParams from '../../components/urlSearchParams'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { UserContext } from '../../context api/UserContext'
import { formTokenHeader } from '../../lib/HeaderHelper'
import { toastMessage } from '../../shared/AlertPopup'
import { API } from '../../shared/API'
import { error, ROUTES, success } from '../../shared/constants'
import { useDownload } from '../../hooks/Download/useDownload'

export const useSalesChannelType = () => {
  const user = useContext(UserContext)
  const token = user && user.token
  const header = formTokenHeader(token)
  const history = useHistory()
  const [salesChannelType, setSalesChannelType] = useState(false)
  const { deleteNewSalesChannelType, getNewSalesChannelType } = useContext(ConfigurationContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)
  // const [pdfCsvData, setPdfCsvData] = useState([])
  const { getPdfCsvData, pdfCsvData, setPdfCsvData } = useDownload();

  const getAllSalesChannelType = async (dto = {}) => {
    setLoading(true)
    axios
      .get(API.GET_ALL_SALES_CHANNEL_TYPE(urlSearchParams(dto)), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        setPaginate(data.paginate)
        getNewSalesChannelType(data.data)
        getPdfCsvData('GET_ALL_SALES_CHANNEL_TYPE', {...dto, download : true})
        // setPdfCsvData({ headings: data.headings, headingValues: data.headingValues })
      })
      .catch((err) => {
        //console.log(err)
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const addSalesChannelType = (dto) => {
    setLoading(true)
    axios
      .post(API.ADD_SALES_CHANNEL_TYPE, dto, header)
      .then(({ status, data }) => {
        //console.log('DATA : ', data)
        setLoading(false)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('SalesChannelType  Added Successfully', success)
        history.push(ROUTES.SALES_CHANNEL_TYPE)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }
  const updateSalesChannelType = (dto) => {
    setLoading(true)
    axios
      .put(API.EDIT_SALES_CHANNEL_TYPE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('SalesChannelType  Update Successfully', success)
        history.push(ROUTES.SALES_CHANNEL_TYPE)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const getSalesChannelType = (dto) => {
    setLoading(true)
    axios
      .get(API.GET_SALES_CHANNEL_TYPE(dto.salesChannelTypeId), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }

        setSalesChannelType(data.data)
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteSalesChannelType = (dto, setSelected) => {
    setLoading(true)
    axios
      .delete(API.DELETE_SALES_CHANNEL_TYPE(dto.salesChannelTypeId), header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage('SalesChannelType Deleted Successfully', success)

        deleteNewSalesChannelType(dto.salesChannelTypeId)
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const deleteManySalesChannelType = (dto, setSelected) => {
    setLoading(true)
    axios
      .post(API.DELETE_MANY_SALES_CHANNEL_TYPE, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 200) {
          return toastMessage('Something Went Wrong !', error)
        }
        toastMessage(`${dto.salesChannelTypeId.length} SalesChannelType Deleted Successfully`, success)

        dto.salesChannelTypeId.map((item) => deleteNewSalesChannelType(item))
        setSelected([])
      })
      .catch((err) => {
        setLoading(false)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error || (err.response.data.errors.length && err.response.data.errors[0].msg), error)
        }
      })
  }

  const BulkUpload = async (dto) => {
    setLoading(true)
    axios
      .post(API.BULK_UPLOAD, dto, header)
      .then(({ status, data }) => {
        setLoading(false)
        //console.log('DATA : ', data)
        if (status !== 201) {
          return toastMessage('Something Went Wrong !', error)
        }
        // data.data.map((item) => addNewReg(item))
        toastMessage(`${data.data.length} Data Inserted Successfully`, success)
      })
      .catch((err) => {
        setLoading(false)
        //console.log(err)
        if (err.response) {
          //console.log(err.response)
          return toastMessage(err.response.data.error, error)
        }
      })
  }

  return {
    addSalesChannelType,
    getAllSalesChannelType,
    deleteSalesChannelType,
    getSalesChannelType,
    salesChannelType,
    updateSalesChannelType,
    deleteManySalesChannelType,
    BulkUpload,
    loading,
    paginate,
    pdfCsvData

  }
}
